import styled from '@emotion/styled'

import { BOX_PAIR_MAX_WIDTH } from '../../../../components/AdviceSummary/shared'
import { SmallTertiaryButton } from '../../../../components/Button'

export { AdviceColumnHeading, AdviceMobileHeading } from '../../../../components/advice/shared'

export const Heading = styled.h1`
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.875rem;
  font-weight: 400;
  line-height: 1.3;
  text-align: center;
  max-width: 720px;
  margin: 0;
  color: ${p => p.theme.mediumGray};

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`

export const Amount = styled.span`
  font-weight: 700;
  color: ${p => p.theme.darkestGray};
`

export const Subheading = styled.p`
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.125rem;
  line-height: 1.4;
  text-align: center;
  margin: 16px 0 0;
  color: ${p => p.theme.lightestGray};
`

export const LastWord = styled.span`
  white-space: nowrap;
`

export const HelpAnchor = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
`

// Desktop keeps the skip action above the charts as a link.
export const SkipRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`

// Tablet and mobile put it below the charts instead, as a full-width pill. The cap
// matches the summary's walk-me-through button so it does not span the whole step.
export const SkipToSummaryButton = styled(SmallTertiaryButton)`
  width: 100%;
  max-width: ${BOX_PAIR_MAX_WIDTH}px;
  margin-top: 30px;
`

export const ChartsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  column-gap: 80px;
  row-gap: 32px;
  width: 100%;
  margin-top: 64px;

  @media (max-width: 600px) {
    margin-top: 40px;
  }
`

export const ChartColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  row-gap: 16px;

  @media (max-width: 600px) {
    row-gap: 10px;
  }
`

// The current donut is shorter than the modified donut. Bottom-aligning them
// lines up the current ring with the modified donut's inner ring.
export const DonutBox = styled.div`
  flex: 0 0 auto;
  max-width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`

export const ReplacementLine = styled.div`
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: ${p => (p.compact ? '0.875rem' : '1.125rem')};
  text-align: center;
  color: ${p => (p.active ? p.theme.primaryColor : p.theme.lightestGray)};
  font-weight: ${p => (p.active ? 700 : 400)};
`

export const MobileFigures = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 8px;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  color: ${p => p.theme.lightestGray};
`

export const Figure = styled.div`
  text-align: center;
  font-weight: ${p => (p.bold ? 700 : 400)};
`
